<template>
  <div class="contact">
    <FixedHeader
      :showLoginBtn="true"
      :showSearch="false"
      @clickedLogin="showLogin = !showLogin"
      :showLogin="showLogin"
    >
      <b-button
        class="back-button"
        type="is-text"
        icon-left="arrow-left"
        size="is-medium"
        @click="goTo()"
      ></b-button>
      <a @click="goTo()">
        <img
          class="logo"
          alt="Pinwall logo"
          :src="
            require(`../assets/img/${
              darkMode ? 'pinwall-logo-new-dark.svg' : 'pinwall-logo-new.svg'
            }`)
          "
        />
      </a>
    </FixedHeader>
    <div class="contact__info">
      <h1>{{ $t("contact.name") }}</h1>
      <h2>{{ $t("contact.question") }}</h2>
      <span>
        {{ $t("contact.description") }}
      </span>
      <h3>{{ $t("contact.information") }}</h3>
      <i class="material-icons-round">email</i>
      <a
        href="mailto:info.pinwall@gmail.com"
        target="_blank"
        rel="noreferrer noopener"
        >info.pinwall@gmail.com</a
      >
    </div>
    <Footer />
  </div>
</template>

<script>
import FixedHeader from "../components/FixedHeader";
import Footer from "@/components/Footer";
import { goTo } from "../mixins/goTo.js";
import { mapGetters } from "vuex";

export default {
  name: "contact",
  data: () => {
    return {
      showLogin: false
    };
  },
  computed: {
    ...mapGetters(["darkMode"])
  },
  components: {
    FixedHeader,
    Footer
  },
  mixins: [goTo],
  mounted: function() {
    window.scrollTo(0, 0);
  }
};
</script>

<style></style>
